/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Readiness_HintInputs */

const cs_portals_readiness_hint = /** @type {(inputs: Portals_Readiness_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kompatibilita polí napříč povolenými portály. Chybějící povinná pole doplníte v detailu nemovitosti.`)
};

const en_portals_readiness_hint = /** @type {(inputs: Portals_Readiness_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Field compatibility across allowed portals. Fill missing mandatory fields on the property.`)
};

/**
* | output |
* | --- |
* | "Field compatibility across allowed portals. Fill missing mandatory fields on the property." |
*
* @param {Portals_Readiness_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_readiness_hint = /** @type {((inputs?: Portals_Readiness_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Readiness_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_readiness_hint(inputs)
	return cs_portals_readiness_hint(inputs)
});